module.exports = __webpack_public_path__ + "static/img/pro8.5a62a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro8.png
// module id = nYD/
// module chunks = 0